export const palette = {
  primary: {
    main: '#512D6D',
    light: '#69408A',
    dark: '#3A1D50',
    contrastText: '#FFF',
  },
  secondary: {
    main: '#6DCDB8',
    light: '#A1DFD1',
    dark: '#459382',
    contrastText: '#000',
  },
  error: {
    main: '#D32F2F',
    light: '#EF5350',
    dark: '#7E1C1C',
    contrastText: '#FFF',
  },
  warning: {
    main: '#EF6C00',
    light: '#FF9800',
    dark: '#E65100',
    contrastText: '#FFF',
  },
  info: {
    main: '#0277BD',
    light: '#03A9F4',
    dark: '#01579B',
    contrastText: '#FFF',
  },
  success: {
    main: '#2E7D32',
    light: '#4CAF50',
    dark: '#1B5E20',
    contrastText: '#FFF',
  },
};
